import React from "react";

const TripleCircleHorizontal = ({
  width = 16,
  height = 16,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
  >
    <circle cx="2" cy="8.5" r="2" fill="#939393" />
    <circle cx="8" cy="8.5" r="2" fill="#939393" />
    <circle cx="14" cy="8.5" r="2" fill="#939393" />
  </svg>
);

export default TripleCircleHorizontal;
